import Tab from "./Tab";
import Button from "./Button.vue";
import Group from "./Group.vue";
import List from "./List.vue";
import Panels from "./Panels.vue";
import Panel from "./Panel.vue";

const TabComponent = Object.assign(Tab, {
  Button,
  Group,
  List,
  Panels,
  Panel,
});

export default TabComponent;
